/**
 * 1.66 (192) — a café's tables: the switch, the tables screen, the open bill, the checkout, Settings. The paper
 * (kitchen slip, cancel slip, client check) is a document, Georgian whatever the device speaks (lib/print-tables.ts).
 */
export const tables = {
  // the switch (Settings → მარტივი რეჟიმი)
  'feat.tables': 'მაგიდები (კაფე / რესტორანი)',
  'feat.tables.shows': 'დარბაზი, მაგიდების ეკრანი, ღია ანგარიში და სამზარეულოს ფურცელი',
  'feat.why.tablesOff': 'ჩართე, როცა სტუმრებს მაგიდასთან ემსახურები',
  // 1.69 — the guests' table QR (needs the tables)
  'feat.tableQr': 'QR მაგიდებზე (სტუმრის მენიუ)',
  'feat.tableQr.shows': 'სტუმარი QR-ით იძახებს მიმტანს, ითხოვს ანგარიშს და უკვეთავს მენიუდან — მიმტანის დადასტურებით',
  'feat.why.tableQrOff': 'ჩართე, როცა ყველა სალარო და მიმტანის ტელეფონი 1.69-ს აჩვენებს',

  // the tables screen
  'tables.mode.cart': 'სალარო',
  'tables.mode.tables': 'მაგიდები',
  'tables.free': 'თავისუფალი',
  'tables.seats': '{n} ადგილი',
  'tables.seatsUnknown': 'ადგილები უცნობია',
  'tables.guests': '{n} სტუმარი',
  'tables.minutes': '{n} წთ',
  'tables.hoursMinutes': '{h} სთ {m} წთ',
  'tables.unsent': '{n} არ გაგზავნილა',
  'tables.billed': 'ანგარიში დაიბეჭდა',
  'tables.legend.open': 'დაკავებული',
  'tables.summary': '{n} დაკავებული · {sum} ღია',
  'tables.empty': 'მაგიდები ჯერ არ არის — მათ მფლობელი ამატებს: პარამეტრები → ფილიალები → „დარბაზი და მაგიდები"',
  'tables.toSettings': 'მაგიდების დამატება',

  // the open bill
  'tables.back': 'მაგიდები',
  'tables.opened': 'გაიხსნა {time}',
  'tables.sent': 'გაგზავნილი · №{n} · {time}',
  'tables.new': 'ახალი · ჯერ არ გაგზავნილა',
  'tables.copy': 'ასლი',
  'tables.cancelLine': 'გაუქმება',
  'tables.addNote': '+ კომენტარი',
  'tables.note': 'კომენტარი',
  'tables.notePh': 'მაგ. ხახვის გარეშე',
  'tables.less': 'ერთით ნაკლები',
  'tables.more': 'ერთით მეტი',
  'tables.remove': 'წაშლა',
  'tables.total': 'სულ',
  'tables.sendN': 'გაგზავნა · {n} ახალი',
  'tables.send': 'გაგზავნა',
  'tables.check': 'ანგარიში',
  'tables.pay': 'გადახდა',
  'tables.move': 'გადატანა',
  'tables.guestsBtn': 'სტუმრები',
  'tables.cancelBill': 'ანგარიშის გაუქმება',
  'tables.emptyBill': 'ანგარიში ცარიელია — დაამატე პროდუქცია',
  'tables.howMany': 'რამდენი სტუმარია?',
  'tables.skip': 'გამოტოვება',
  'tables.open': 'გახსნა',
  'tables.save': 'შენახვა',
  'tables.leaveTitle': '{n} პოზიცია არ გაგზავნილა',
  'tables.leaveSub': 'სამზარეულომ ჯერ არ იცის. გავაგზავნოთ?',
  'tables.leaveKeep': 'დატოვება',
  'tables.stay': 'დარჩენა',
  'tables.sendNothing': 'ახალი არაფერია',
  'tables.sentOk': 'გაიგზავნა №{n}',
  'tables.noShiftPay': 'გადახდისთვის ჯერ გახსენი ცვლა',
  'tables.offline': 'კავშირი არ არის — მაგიდებთან მუშაობა ინტერნეტს საჭიროებს',
  'tables.saveFailed': 'შენახვა ვერ მოხერხდა — კიდევ სცადე',
  'tables.codeNotFound': 'ეს კოდი ვერ მოიძებნა: {code}',

  // cancelling a sent portion / the whole bill
  'tables.cancelTitle': 'ულუფის გაუქმება',
  'tables.cancelHowMany': 'რამდენი გაუქმდეს ({n}-დან)',
  'tables.reason': 'მიზეზი',
  'tables.reason.changed': 'სტუმარმა გადაიფიქრა',
  'tables.reason.mistake': 'შეცდომით ჩაიწერა',
  'tables.reason.failed': 'ვერ მომზადდა',
  'tables.reason.other': 'სხვა…',
  'tables.reasonPh': 'მიზეზი',
  'tables.ownerPin': 'მფლობელის PIN',
  'tables.cancelSlipNote': 'სამზარეულოში გაუქმების ფურცელი დაიბეჭდება.',
  'tables.cancelN': 'გაუქმება · {n}',
  'tables.close': 'დახურვა',
  'tables.cancelBillTitle': 'ანგარიშის გაუქმება',
  'tables.cancelBillSent': 'გაგზავნილი პოზიციები გაუქმდება — საჭიროა მიზეზი და მფლობელის PIN.',
  'tables.cancelBillEmpty': 'ანგარიში დაიხურება, გადახდის გარეშე.',
  'tables.cancelBillConfirm': 'გაუქმება',

  // moving
  'tables.moveTitle': 'სად გადავიტანოთ?',
  'tables.moveNone': 'თავისუფალი მაგიდა არ არის',

  // the checkout
  'tables.payTitle': 'მაგიდა {name}',
  'tables.payGuests': 'მაგიდა {name} · {n} სტუმარი',
  'tables.paperDiffers': 'ამ ქაღალდზე ეწერა ₾{was} ({time})',
  'tables.alreadyPaid': 'ეს მაგიდა უკვე გადახდილია',
  'tables.alreadyPaidCopy': 'ჩეკის ასლი',
  'tables.billChanged': 'ანგარიში შეიცვალა — გადაამოწმე',
  'tables.payOffline': 'მაგიდის ანგარიში ინტერნეტით იხურება — კავშირი არ არის',
  'tables.payLost': 'კავშირი გაწყდა — შეამოწმე მაგიდა და კიდევ დააჭირე',
  'tables.backToBill': 'ანგარიშზე დაბრუნება',

  // the shift close and the history
  'tables.openAtClose': 'ღია მაგიდა {n} · ₾{sum}',
  'tables.openAtCloseHint': 'ღია მაგიდები Z-ში არ ითვლება — გადაიხდება, როცა სტუმარი გადაიხდის',
  'tables.historyChip': 'მაგიდა {name}',
  'tables.productOnBill': 'ეს პროდუქტი ღია მაგიდის ანგარიშზეა — ჯერ ანგარიში დახურე',

  // Settings — halls and tables
  'tables.settings.title': 'დარბაზი და მაგიდები',
  'tables.settings.sub': 'მაგიდები ფილიალის მიხედვით. გამოყენებული მაგიდა არ იშლება — უქმდება.',
  'tables.settings.addHall': '+ დარბაზი',
  'tables.settings.addTable': '+ მაგიდა',
  'tables.settings.bulk': 'ერთბაშად დამატება',
  'tables.settings.bulkTitle': 'რამდენი მაგიდა დავამატოთ?',
  'tables.settings.bulkFrom': '1-დან {n}-მდე',
  'tables.settings.hallName': 'დარბაზის სახელი',
  'tables.settings.hallPh': 'მაგ. ტერასა',
  'tables.settings.tableName': 'მაგიდის ნომერი ან სახელი',
  'tables.settings.seats': 'ადგილები',
  'tables.settings.hall': 'დარბაზი',
  'tables.settings.noHall': 'დარბაზის გარეშე',
  'tables.settings.count': '{n} მაგიდა',
  'tables.settings.retire': 'გაუქმება',
  'tables.settings.retired': 'გაუქმებული',
  'tables.settings.restore': 'აღდგენა',
  'tables.settings.edit': 'შეცვლა',
  'tables.settings.switchOff': '„მაგიდები" გამორთულია — ჩართე „მარტივ რეჟიმში"',
  'tables.settings.saved': 'შენახულია',
  'tables.settings.nameTaken': 'ასეთი მაგიდა უკვე არის',
  // 1.68 (196) — the rate, free on payment, the shape, this device
  'tables.settings.shape': 'ფორმა',
  'tables.settings.shape.auto': 'ავტომატური',
  'tables.settings.shape.round': 'მრგვალი',
  'tables.settings.shape.square': 'კვადრატი',
  'tables.settings.shape.long': 'გრძელი',
  'tables.settings.money': 'მომსახურება და გადახდა',
  'tables.settings.pct': 'მომსახურება %',
  'tables.settings.pctHint': 'ანგარიშს ცალკე სტრიქონად ემატება. ჩართე მაშინ, როცა ყველა სალარო და მიმტანის ყველა ტელეფონი 1.68-ს აჩვენებს.',
  'tables.settings.freeOnPay': 'მაგიდა თავისუფლდება გადახდისთანავე',
  'tables.settings.freeOnPayHint': 'გამორთულზე გადახდილი მაგიდა დაკავებული რჩება, სანამ მიმტანი ან სალარო არ მონიშნავს „მაგიდა გათავისუფლდა".',
  'tables.settings.device': 'ეს მოწყობილობა',
  'tables.settings.deviceBranch': 'ფილიალი: {name}',
  'tables.settings.bar': 'ეს სალარო ბარიცაა',
  'tables.settings.barHint': 'ბარის შეკვეთები აქ ჩნდება ზარით; „მზადაა" მიმტანს ტელეფონზე აცნობებს.',
  'tables.settings.checks': 'მიმტანების ანგარიშებს ეს სალარო ბეჭდავს',
  'tables.settings.checksHint': 'მიმტანი ანგარიშს ითხოვს — ჩეკი აქ თავისით იბეჭდება.',
  'tables.settings.silentHow': 'ჩუმი ბეჭდვა: როგორ?',

  // a category's station
  'tables.station': 'სად მიდის შეკვეთა',
  'tables.station.kitchen': 'სამზარეულო',
  'tables.station.bar': 'ბარი',
  'tables.station.none': 'არცერთი',

  // the server's refusals
  'tables.err.TABLE_BILL_CLOSED': 'ეს ანგარიში უკვე დახურულია',
  // 1.67 (193) — the kitchen and the waiter
  'tables.err.TABLE_LINE_SERVED': 'კერძი უკვე მიტანილია — „მზადაა“ აღარ ბრუნდება',
  'tables.err.TABLE_LINE_NOT_READY': 'კერძი ჯერ არ არის მზად — სამზარეულომ ჯერ უნდა მონიშნოს',
  'tables.err.TABLE_WAITER_ONLY': 'მაგიდას მხოლოდ მიმტანი იბარებს',
  'tables.err.TABLE_WAITER_FORBIDDEN': 'მიმტანის ანგარიშით ეს შეუძლებელია',
  'tables.err.TABLE_TOO_MANY_LINES': 'ერთად ძალიან ბევრი კერძია — ნაწილ-ნაწილ მონიშნე',
  'tables.err.TABLE_STATION_INVALID': 'სამზარეულოს განყოფილება არასწორია',
  'tables.checkAsked': 'მაგიდა {name} ანგარიშს ითხოვს',
  'tables.err.TABLE_BILL_CHANGED': 'ანგარიში სხვა მოწყობილობაზე შეიცვალა — გადაამოწმე და კიდევ სცადე',
  'tables.err.TABLE_LINES_MISMATCH': 'გადახდა ანგარიშს არ ემთხვევა — გადაამოწმე და კიდევ სცადე',
  'tables.err.TABLE_BUSY': 'მაგიდა დაკავებულია',
  'tables.err.TABLE_NOT_FOUND': 'მაგიდა ან ანგარიში ვერ მოიძებნა',
  'tables.err.TABLE_BRANCH_FORBIDDEN': 'ეს მაგიდა სხვა ფილიალისაა',
  'tables.err.TABLE_PRODUCT_INVALID': 'ეს პროდუქტი მაგიდის ანგარიშზე ვერ დაემატება',
  'tables.err.TABLE_QTY_INVALID': 'რაოდენობა არასწორია',
  'tables.err.TABLE_LINE_LOCKED': 'გაგზავნილი პოზიცია აღარ იცვლება — გამოიყენე „გაუქმება"',
  'tables.err.TABLE_LINE_NOT_SENT': 'ეს პოზიცია ჯერ არ გაგზავნილა — უბრალოდ წაშალე',
  'tables.err.TABLE_REASON_REQUIRED': 'მიუთითე მიზეზი',
  'tables.err.TABLE_PIN_REQUIRED': 'საჭიროა მფლობელის PIN',
  'tables.err.TABLE_GUESTS_INVALID': 'სტუმრების რაოდენობა არასწორია',
  'tables.err.TABLE_NOTE_TOO_LONG': 'კომენტარი ძალიან გრძელია',
  'tables.err.TABLE_TOTAL_INVALID': 'თანხა არასწორია',
  'tables.err.TABLE_OFFLINE_REPLAY': 'მაგიდის ანგარიში მხოლოდ ინტერნეტით იხურება',
  'tables.err.TABLE_REF_INVALID': 'გადახდა ამ ანგარიშს არ ეკუთვნის',
  'tables.err.TABLE_HALL_INVALID': 'დარბაზი ამ ფილიალისა არ არის',
  'tables.err.TABLE_IN_USE': 'ეს მაგიდა უკვე გამოიყენებოდა — სხვა ფილიალში ვერ გადავა',
  'tables.err.PRODUCT_ON_OPEN_BILL': 'ეს პროდუქტი ღია მაგიდის ანგარიშზეა — ჯერ ანგარიში დახურე',
  // 1.68 (196) — the service product, freeing a table, the check printing, the waiter numbers
  'tables.err.TABLE_SERVICE_PRODUCT': 'მომსახურება ანგარიშს თავისით ემატება — ცალკე ვერ დაემატება',
  'tables.err.TABLE_HAS_OPEN_BILL': 'ამ მაგიდაზე ღია ანგარიშია — ჯერ ანგარიში დახურე',
  'tables.err.TABLE_CHECK_STALE': 'ჩეკის მოთხოვნა უკვე შეიცვალა — გადაამოწმე და კიდევ სცადე',
  'tables.err.TABLE_CHECK_SNAPSHOT': 'ანგარიში ახლახან შეიცვალა — გადაამოწმე და ჩეკი კიდევ დაბეჭდე',
  'tables.err.TABLE_CHECK_TOKEN': 'ეს ბეჭდვა სხვა მოწყობილობამ დაიწყო',
  'tables.err.TABLE_CHECK_STATE': 'ამ ჩეკის ბეჭდვა უკვე აღრიცხულია',
  'tables.err.TABLE_PCT_INVALID': 'მომსახურების პროცენტი 0-დან 30-მდეა, მძიმის შემდეგ მაქსიმუმ ერთი ციფრით',
  'tables.err.TABLE_SERVICE_MISMATCH': 'მომსახურების თანხა ანგარიშს არ ემთხვევა — ანგარიში განახლდა, გადაამოწმე და კიდევ სცადე',
  'tables.err.SERVICE_CHARGE_NOT_HERE': 'მაგიდის მომსახურება მხოლოდ მაგიდის ანგარიშს ეკუთვნის — აქ ვერ გამოიყენება',
  'tables.err.SERVICE_PRODUCT_LOCKED': 'მაგიდის მომსახურება პროგრამის საკუთარი პროდუქტია — ვერ წაიშლება',
  'tables.err.WAITER_STATS_FORBIDDEN': 'ამ ციფრებს მხოლოდ მფლობელი და თავად მიმტანი ხედავს',
  'tables.err.WAITER_STATS_PERIOD': 'აირჩიე პერიოდი — მაქსიმუმ 93 დღე',
  // 1.69 (197/198) — the guests' requests, the parties at the tables, the QR tokens, the reservation
  'tables.err.TABLE_OCCUPIED': 'ეს მაგიდა დაკავებულია — სტუმარი ზის ან დაჯავშნილია',
  'tables.err.TABLE_QR_OFF': 'QR მაგიდებზე გამორთულია',
  'tables.err.TABLE_SEND_SET_INVALID': 'შეკვეთა შეიცვალა — გადაამოწმე და კიდევ სცადე',
  'tables.err.REQUEST_CLOSED': 'ეს მოთხოვნა უკვე დახურულია',
  'tables.err.REQUEST_STALE': 'სტუმარმა შეკვეთა შეცვალა — გადაამოწმე და კიდევ დაადასტურე',
  'tables.err.REQUEST_NOT_YOURS': 'ამ მაგიდას სხვა მიმტანი ემსახურება',
  'tables.err.REQUEST_ADDON_INVALID': 'დამატებები შეკვეთას არ ემთხვევა — გადაამოწმე და კიდევ სცადე',
  'tables.err.REQUEST_EMPTY': 'შეკვეთაში არაფერი დარჩა — თუ არაფერი უნდათ, უარყავი',
  'tables.err.QR_OWNER_ONLY': 'მაგიდების QR-ს მხოლოდ მფლობელი მართავს',
  'tables.err.RESERVE_INVALID': 'ჯავშნის დრო ან სახელი არასწორია',
  'tables.req.taken': 'უკვე აიღო: {name}',
  'tables.req.takenAny': 'ეს მოთხოვნა სხვამ უკვე აიღო',
  'tables.req.toast.call': '{table} — გიძახებენ',
  'tables.req.toast.order': '{table} — ახალი შეკვეთა მენიუდან',
  'tables.req.toast.check': '{table} — ანგარიშს ითხოვენ',
  'tables.req.toast.any': 'სტუმრის ახალი მოთხოვნა',
  'tables.freeOnPayWarn': '{n} სტუმრის შეკვეთა ელოდება — გადახდისას დაიხურება',
  'tables.req.confirm.title': '{table} — სტუმრის შეკვეთა',
  'tables.req.confirm.sub': 'QR-ით · {ago} · გადაამოწმე სტუმართან',
  'tables.req.confirm.guestNote': 'სტუმარი: „{note}“',
  'tables.req.confirm.removed': 'ამოღებულია — არ გაიგზავნება',
  'tables.req.confirm.gone': 'აღარ არის',
  'tables.req.confirm.addon': '+ {name} × {n}',
  'tables.req.confirm.more': 'სხვა რამე სურს? დაადასტურე და ჩვეულებრივ დაამატე ანგარიშზე.',
  'tables.req.confirm.send': 'დადასტურება და გაგზავნა · {n}',
  'tables.req.confirm.orReject': 'ან უარყოფა — მიზეზი:',
  'tables.req.confirm.reject': 'შეკვეთის უარყოფა',
  'tables.req.confirm.reasonPlaceholder': 'მიზეზი',
  'tables.req.confirm.sent': 'შეკვეთა სამზარეულოში გაიგზავნა',
  'tables.req.confirm.rejected': 'შეკვეთა უარყოფილია',
  'tables.req.reason.changed': 'სტუმარმა გადაიფიქრა',
  'tables.req.reason.nobody': 'მაგიდასთან არავინაა',
  'tables.req.reason.other': 'სხვა',
  'tables.req.now': 'ახლახან',
  'tables.req.ago': '{time} წინ',
  'tables.req.strip': 'გიძახებენ',
  'tables.req.call': 'გამოძახება',
  'tables.req.order': 'სტუმრის შეკვეთა · {n} კერძი',
  'tables.req.check': 'ანგარიშის მოთხოვნა',
  'tables.req.everyone': 'ყველას',
  'tables.req.yours': 'შენი მაგიდა',
  'tables.req.takenBy': 'აიღო: {name}',
  'tables.req.take': 'შეკვეთის აღება',
  'tables.req.coming': 'მივდივარ',
  'tables.req.open': 'ნახვა',
  'tables.req.print': 'ანგარიშის ბეჭდვა',
  'tables.req.okay': 'კარგი',
  'tables.req.printed': 'ანგარიში ბეჭდვაზე გაიგზავნა',
  'tables.req.noBill': 'ღია ანგარიში არ არის — უთხარი სტუმარს',
  'tables.party.waitingSub': 'სტუმარი ზის {time} — ანგარიში ჯერ არ გახსნილა',
  'tables.party.reservedSub': 'დაჯავშნილია {time}',
  'tables.party.freeSub': 'მაგიდა თავისუფალია',
  'tables.party.newBill': 'ახალი ანგარიში',
  'tables.party.seat': 'სტუმარი დაჯდა',
  'tables.party.free': 'თავისუფალია',
  'tables.party.reserve': 'დაჯავშნა',
  'tables.party.reserveClear': 'ჯავშნის მოხსნა',
  'tables.party.seatedOk': 'მაგიდა {name} — სტუმარი დაჯდა',
  'tables.reserve.time': 'როდის',
  'tables.reserve.name': 'ვისზე (არასავალდებულო)',
  'tables.reserve.save': 'დაჯავშნა',
  'tables.reserve.ok': 'მაგიდა {name} დაჯავშნილია {time}-ზე',
  'tables.reserve.cleared': 'მაგიდა {name} — ჯავშანი მოიხსნა',
  // 1.68 (196) — the photo tiles, the seated table, the bar at the till, the check printing, the paper scan
  'tables.status.taken': 'დაკავებული',
  // 1.69 — a party seated with no bill yet; a reservation inside its window; one further away
  'tables.status.waiting': 'ელოდება · {time}',
  'tables.status.reserved': 'დაჯავშნილია {time}',
  'tables.status.reservedLater': 'ჯავშანი {time}',
  'tables.legend.waiting': 'ელოდება',
  'tables.legend.reserved': 'დაჯავშნილი',
  'tables.req.kind.call': 'გიძახებენ',
  'tables.req.kind.order': 'შეკვეთა მენიუდან',
  'tables.req.kind.check': 'ანგარიშს ითხოვენ',
  'tables.status.paid': 'გადახდილია {time}',
  'tables.legend.paid': 'გადახდილი',
  'tables.legend.attention': 'ყურადღება',
  'tables.tableN': 'მაგიდა {name}',
  'tables.seated.sub': 'სტუმრები წავიდნენ? მაგიდა გათავისუფლდება. თუ ისევ შეუკვეთეს — ახალი ანგარიში გაიხსნება.',
  'tables.seated.free': 'მაგიდა გათავისუფლდა',
  'tables.seated.new': 'ახალი შეკვეთა',
  'tables.freedOk': 'მაგიდა {name} თავისუფალია',
  'tables.bar.title': 'ბარი',
  'tables.bar.empty': 'ბარისთვის შეკვეთა არ არის',
  'tables.bar.new': 'ბარი: მაგიდა {name}',
  'tables.serviceLine': 'მომსახურება {pct}%',
  'tables.copyCheck': 'ანგარიშის ასლი',
  'tables.check.printed': 'ჩეკი დაიბეჭდა',
  'tables.check.failed': 'ჩეკი ვერ დაიბეჭდა — კიდევ სცადე',
  'tables.check.taken': 'ეს ჩეკი სხვა სალარომ უკვე დაბეჭდა',
  'tables.check.auto': 'მაგიდა {name}: ჩეკი დაიბეჭდა',
  'tables.check.autoFailed': 'მაგიდა {name}: ჩეკი ვერ დაიბეჭდა — დააჭირე „ანგარიში"',
  'tables.paper.notFound': 'ჩეკი {code} ვერ მოიძებნა',
  'tables.paper.otherBranch': 'ეს ჩეკი სხვა ფილიალისაა',
  'tables.paper.scanHere': 'აქ მხოლოდ ჩეკის კოდი იკითხება — პროდუქტი მაგიდის ანგარიშში დაამატე',
} as const
